import BaseModel from '@/app-core/lib/data/model/BaseModel'
import GuestValidator from '@/app-core/api/validations/customer/GuestValidator'
import GuestResource from '@/app-core/api/resources/customer/GuestResource'

export default class GuestModel extends BaseModel {
  constructor(payload = {}, resource = GuestResource, validator = GuestValidator) {
    super(payload, resource, validator)
  }

  boot() {
    super.boot()

    this.guarded = []
  }

  /* PROPERTIES */

  /* METHODS */
}
